import React from "react";

export default function Empty() {
  return <>Empty</>;
}
